export default __webpack_public_path__ + "static/media/agency4.8365e96d.png";